// extracted by mini-css-extract-plugin
export default {"feed":"styles_feed__Id3Cf"};